import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconDriveType: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="drive-type">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 3A2.5 2.5 0 0 0 4 5.5v2a2.5 2.5 0 0 0 5 0v-.4h2.4v2.992a2 2 0 0 0 0 3.816V16.9H9v-.4a2.5 2.5 0 0 0-5 0v2a2.5 2.5 0 0 0 5 0v-.4h6v.4a2.5 2.5 0 0 0 5 0v-2a2.5 2.5 0 0 0-5 0v.4h-2.4v-2.991a2 2 0 0 0 0-3.818V7.1H15v.4a2.5 2.5 0 0 0 5 0v-2a2.5 2.5 0 0 0-5 0v.4H9v-.4A2.5 2.5 0 0 0 6.5 3Zm1.3 4.5v-2a1.3 1.3 0 0 0-2.6 0v2a1.3 1.3 0 0 0 2.6 0Zm0 11v-2a1.3 1.3 0 1 0-2.6 0v2a1.3 1.3 0 1 0 2.6 0Zm9.7-14.3a1.3 1.3 0 0 1 1.3 1.3v2a1.3 1.3 0 1 1-2.6 0v-2a1.3 1.3 0 0 1 1.3-1.3Zm1.3 12.3a1.3 1.3 0 1 0-2.6 0v2a1.3 1.3 0 1 0 2.6 0v-2Zm-6-4.5a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Z"
    />
  </Icon>
);
